var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowFatshare = function SvgArrowFatshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M15.833 6.882 10.12 1.168a.571.571 0 0 0-.976.403v2.882c-1.853.159-3.9 1.066-5.583 2.494-2.027 1.72-3.29 3.936-3.554 6.24a.857.857 0 0 0 1.477.685c.786-.836 3.581-3.481 7.66-3.714V13a.571.571 0 0 0 .976.403l5.714-5.714a.57.57 0 0 0 0-.807m-5.547 4.739V9.57A.57.57 0 0 0 9.714 9c-2.005 0-3.959.523-5.806 1.557a14 14 0 0 0-2.612 1.894c.414-1.703 1.458-3.322 3.003-4.633 1.659-1.406 3.683-2.247 5.415-2.247A.57.57 0 0 0 10.286 5V2.95l4.335 4.335z"
  })));
};
export default SvgArrowFatshare;